import React, { Component } from "react";

const BG = "#1a2332";
const BG_ROW = "#151d28";
const BG_ROW_HOVER = "#1f2a3a";
const BG_SELECTED = "#2d4a6e";
const TEXT = "#e8eef5";
const TEXT_MUTED = "#8a9aac";

/**
 * Icon URLs: /pearlDoser/menu/<encodeURIComponent(label)>.png
 * Filenames on disk use spaces (e.g. "Data Log.png"); encoding yields .../Data%20Log.png for the URL.
 */
function iconSrc(label) {
  return `/pearlDoser/menu/${encodeURIComponent(label)}.png`;
}

const sectionTitleStyle = {
  fontSize: 11,
  letterSpacing: "0.08em",
  textTransform: "uppercase",
  color: TEXT_MUTED,
  marginBottom: 8,
  marginTop: 0,
  fontWeight: 600,
};

const outerStyle = {
  width: 240,
  boxSizing: "border-box",
  backgroundColor: BG,
  color: TEXT,
  display: "flex",
  flexDirection: "column",
  alignSelf: "flex-start",
  overflowY: "auto",
  fontFamily: "system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
  fontSize: 14,
};

const menuBtnBase = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  padding: "10px 12px",
  marginBottom: 4,
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
  textAlign: "left",
  fontSize: 14,
  fontFamily: "inherit",
  color: TEXT,
  backgroundColor: BG_ROW,
  transition: "background-color 0.12s ease",
};

export default class DoserMenu extends Component {
  constructor(props) {
    super(props);
    this.state = { oldOpen: false };
  }

  toggleOld = () => {
    this.setState((prev) => ({ oldOpen: !prev.oldOpen }));
  };

  render() {
    const { unit, type, selPage, alarms, fwVers, prdRev, onChange } = this.props;
    const { oldOpen } = this.state;

    const monitorItems = ["Dashboard", "Data Log"];//, "Pearl"
    const configureItems = ["Schedule", "Recipes", "Programs", "Valves",
    "JPro Setup","Alarms","System"];
    const iconAlias = { Programs: "Valves" };
    const oldItems = [
      { label: "Dashboard", value: "Dashboard" },
      { label: "Data Log", value: "Data Log" },
      { label: "Schedule", value: "Old Schedule" },
      { label: "Recipes", value: "Old Recipes" },
      { label: "Valves", value: "Valves" },
      { label: "Alarms", value: "Alarms" },
      { label: "System", value: "Old System" },
    ];

    const renderRow = (label, { indented, keyPrefix, value } = {}) => {
      const pageValue = value != null ? value : label;
      const isSelected = selPage === pageValue;
//       const isAlarms = label === "Alarms";

      const baseBg = isSelected ? BG_SELECTED : BG_ROW;

      const labelStyle = {
        flex: 1,
        marginLeft: 10,
        color: isSelected ? "#fff" : TEXT,
        fontWeight: isSelected ? 600 : 400,
      };

      return (
        <button
          key={keyPrefix ? `${keyPrefix}-${label}` : label}
          type="button"
          tabIndex={0}
          style={{
            ...menuBtnBase,
            backgroundColor: baseBg,
            cursor: "pointer",
            ...(indented ? { paddingLeft: 28 } : null),
          }}
          onClick={() => onChange({ type: "click", value: pageValue })}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onChange({ type: "click", value: pageValue });
            }
          }}
          onMouseEnter={(e) => {
            if (!isSelected) {
              e.currentTarget.style.backgroundColor = BG_ROW_HOVER;
            }
          }}
          onMouseLeave={(e) => {
            if (!isSelected) {
              e.currentTarget.style.backgroundColor = "";
            }
          }}
        >
          <span style={{ display: "flex", alignItems: "center", flex: 1, minWidth: 0 }}>
            <img
              src={iconSrc(iconAlias[label] || label)}
              alt=""
              width={24}
              height={24}
              style={{ flexShrink: 0 }}
            />
            <span style={labelStyle}>{label}</span>
          </span>
        </button>
      );
    };

    const renderOldToggle = () => {
      return (
        <button
          key="Old"
          type="button"
          tabIndex={0}
          style={{
            ...menuBtnBase,
            backgroundColor: BG_ROW,
            cursor: "pointer",
          }}
          onClick={this.toggleOld}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              this.toggleOld();
            }
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = BG_ROW_HOVER;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "";
          }}
          aria-expanded={oldOpen}
        >
          <span style={{ display: "flex", alignItems: "center", flex: 1, minWidth: 0 }}>
            <span
              style={{
                flex: 1,
                color: TEXT,
                fontWeight: 400,
              }}
            >
              Old
            </span>
            <span
              style={{
                color: TEXT_MUTED,
                fontSize: 12,
                marginLeft: 8,
                flexShrink: 0,
              }}
              aria-hidden="true"
            >
              {oldOpen ? "▾" : "▸"}
            </span>
          </span>
        </button>
      );
    };

    return (
      <aside style={outerStyle}>
        <header style={{ padding: "20px 16px 12px" }}>
          <div style={{ fontSize: 18, fontWeight: 700, color: TEXT, marginBottom: 4 }}>
            Pearl iDoser
          </div>
          <div style={{ fontSize: 12, color: TEXT_MUTED, marginBottom: 14 }}>
            Link4 Automation
          </div>
          <div style={{ fontSize: 13, color: TEXT, marginBottom: 6 }}>
            <span style={{ color: TEXT_MUTED, fontSize: 12 }}>Unit </span>
            {unit != null ? String(unit) : "—"}
          </div>
          <div style={{ fontSize: 13, color: TEXT }}>
            <span style={{ color: TEXT_MUTED, fontSize: 12 }}>Type </span>
            {type != null ? String(type) : "—"}
          </div>
        </header>

        <nav style={{ flex: 1, padding: "8px 12px 16px", overflowY: "auto" }}>
          <div style={{ marginBottom: 16 }}>
            <p style={sectionTitleStyle}>Monitor</p>
            {monitorItems.map(renderRow)}
          </div>

          <div style={{ marginBottom: 16 }}>
            <p style={sectionTitleStyle}>Configure</p>
            {configureItems.map(renderRow)}
          </div>

        </nav>

        <footer
          style={{
            padding: "16px",
            borderTop: `1px solid rgba(138, 154, 172, 0.25)`,
            marginTop: "auto",
          }}
        >
          <button
            type="button"
            onClick={() => onChange({ type: "click", value: "back" })}
            style={{
              width: "100%",
              padding: "8px 10px",
              marginBottom: 14,
              borderRadius: 8,
              border: "1px solid rgba(138, 154, 172, 0.35)",
              backgroundColor: "transparent",
              color: TEXT_MUTED,
              fontSize: 12,
              cursor: "pointer",
              fontFamily: "inherit",
              fontWeight: 400,
            }}
          >
            Back to site
          </button>

          <div style={{ fontSize: "12px", color: "#aaa", lineHeight: 1.7 }}>
            <div style={{ marginBottom: 8 }}>
              <a
                href="https://link4controls.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#999", textDecoration: "none" }}
              >
                link4controls.com
              </a>
            </div>
            <div style={{ marginBottom: 8 }}>
              <a
                href="https://link4controls.com/products/pearl-idoser"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#999", textDecoration: "none" }}
              >
                Pearl iDoser product page
              </a>
            </div>
            <div style={{ marginBottom: 14 }}>
              <a
                href="mailto:support@link4controls.com"
                style={{ color: "#999", textDecoration: "none" }}
              >
                support@link4controls.com
              </a>
            </div>
          </div>

          <div
            style={{
              fontSize: "12px",
              color: "#aaa",
              lineHeight: 1.5,
              fontVariantNumeric: "tabular-nums",
            }}
          >
            Pearl iDoser - FW {fwVers != null ? fwVers : "—"}
            <br />
            © 2026 Link4 Automation Inc.
          </div>
        </footer>
      </aside>
    );
//           <div style={{ marginBottom: 16 }}>
//             <p style={sectionTitleStyle}>System</p>
//             {renderOldToggle()}
//             {oldOpen &&
//               oldItems.map((item) =>
//                 renderRow(item.label, {
//                   indented: true,
//                   keyPrefix: "old",
//                   value: item.value,
//                 })
//               )}
//           </div>
  }
}
